module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Fb-Ga-Ha-Ia-Gd.e0d2e575.png";